import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Grid, Box, Typography, Button, Tooltip, Link, Checkbox, FormControlLabel } from '@mui/material';
import { setMlmuserTandcModal } from 'store/slice/DmpSlice';
import TandcActionModal from 'components/mlmuser/action/tandc/TandcActionModal';
import { setMlmUserObj, setPartnerAPISuccess,setselectedPkgObj } from 'store/slice/EcomSlice';
import { bePartnerAPI } from 'api/CoreMlmmgmtWebServices';
import { getUserAPI } from 'api/IdentityServiceAPI';
import { setuserprofileInfo } from 'store/slice/HeaderSlice';
import { openLoginModal } from 'store/slice/HeaderSlice';
import { setMlmuserInitPartnershipModal } from 'store/slice/DmpSlice';
import InitPartnershipActionModal from '../../action/initPartnership/InitPartnershipActionModal';
import HomeIcon from '@mui/icons-material/Home';
import {setOnboardingStep} from 'store/slice/AppSlice';

export default function MlmTandC() {
    const dispatch = useDispatch();
    const [checked, setChecked] = useState(false);
    const [apiInProgress, setApiInProgress] = useState(false);
    const { partnerAPISuccess } = useSelector((state) => state.ecomslice.mlm);
    const { userprofileInfo } = useSelector((state) => state.headerslice);

    const loadUserSuccessCallBack = (response) => {
        dispatch(setuserprofileInfo(response.userprofileInfo));
    }
    const handleSubmit = () => {
        if (userprofileInfo && userprofileInfo.rolename === 'MLM_CUSTOMER') {
            dispatch(openLoginModal(true));
            return;
        }
        if (checked) {
            setApiInProgress(true);
            bePartnerAPI({}, bePartnerSucccess, bePartnerFailure)
        }
    };
    const bePartnerSucccess = (apiResponse) => {
        setApiInProgress(false);
        dispatch(setMlmUserObj(apiResponse.mlmuserInfo));
        dispatch(setPartnerAPISuccess(true));
        getUserAPI(loadUserSuccessCallBack, () => { });
    }
    const bePartnerFailure = (errMsg) => {
        setApiInProgress(false);
        console.log('!!! ERROR !!! ' + errMsg);
    }
    const handleCheckboxChange = (event) => {
        setChecked(event.target.checked);
    };
    const handleLinkClick = () => {
        dispatch(setMlmuserTandcModal(true));
    }
    const InitiatePartnership = () => {
        // dispatch(setselectedPkgObj(null));
        // dispatch(setMlmuserInitPartnershipModal(true));
        dispatch(setOnboardingStep(1));
    }
    const goHome = () => {
        window.location.href = '/';
    }

    return (
        <>

            <Grid>
                <Box sx={{p:1}}>
                    {/* <Typography variant="h6" >
                        By checking the box below, you agree to our Terms and Conditions and Privacy Policy.
                    </Typography> */}
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={checked}
                                onChange={handleCheckboxChange}
                                color="primary"
                            />
                        }
                        label={
                            <Typography variant="h6">
                                I agree to the{" "}
                                <Link href="#" onClick={handleLinkClick} sx={{ cursor: "pointer" }}>
                                    Terms and Conditions
                                </Link>.
                            </Typography>
                        }
                    />

                </Box>
            </Grid>

            <Grid container sx={{ width: '100%' }}>
                <Grid item xs={12}>
                    <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={InitiatePartnership}
                            disabled={!checked}
                        >
                            Initiate Business Association
                        </Button>
                    </Box>
                </Grid>
            </Grid>

            <TandcActionModal />
            <InitPartnershipActionModal />
        </>
    )
}
